var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polygon, _path19, _polygon2, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFgLight4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.34 144.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MARKETING"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.48 32.99 96.46 60.69 96.47 116.1 48.48 143.8 0.5 116.1 0.5 60.69 48.48 32.99",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,116.22,48.42,88.65m.18-.86V33.22m0,55.18L96.17,116",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.29,119.56c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,51.29,119.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8,118.69a.18.18,0,0,1,0,.34.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,52.8,118.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.29,117.82c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,51.29,117.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.31,117.83c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,54.31,117.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.22,117a.63.63,0,0,1,.58,0c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0A.17.17,0,0,1,52.22,117Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.71,116.09a.66.66,0,0,1,.58,0c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0A.18.18,0,0,1,50.71,116.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.84,122.14a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,58.84,122.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.83,122.14a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,55.83,122.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.34,121.26c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,57.34,121.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.32,121.26c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,54.32,121.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.83,120.39c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,55.83,120.39Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.81,120.39c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,52.81,120.39Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.32,119.52c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,54.32,119.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.78,121.28a.58.58,0,0,1,.57,0,.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,59.78,121.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,120.4c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,61.86,120.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37,119.53c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,63.37,119.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88,118.66c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,64.88,118.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.39,117.79c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,66.39,117.79Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9,116.92c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,67.9,116.92Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.27,120.41a.6.6,0,0,1,.58,0,.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,58.27,120.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.36,119.53c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,60.36,119.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,118.66c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,61.86,118.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37,117.79c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,63.37,117.79Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88,116.92c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,64.88,116.92Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.39,116.05a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,66.39,116.05Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9,115.18a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,67.9,115.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.76,119.54a.63.63,0,0,1,.58,0c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0A.17.17,0,0,1,56.76,119.54Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.85,118.66c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,58.85,118.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.36,117.79c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,60.36,117.79Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,116.92c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,61.86,116.92Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37,116.05a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,63.37,116.05Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88,115.18a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,64.88,115.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.39,114.31a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,66.39,114.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.25,118.66a.66.66,0,0,1,.58,0c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0A.18.18,0,0,1,55.25,118.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,113.39s2-12.31,1-17.9L55.41,96.76a52.19,52.19,0,0,1-3.83,17.8h0c-.25.56.06,1.21.89,1.7l2.15,1.23a4.45,4.45,0,0,0,4,.17l5.67-3.28a1.19,1.19,0,0,0,.7-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.61,106.8l-5.87-3.26a.3.3,0,0,0-.43.26c0,1.17-.39,4.57-3.3,11.45h0c-.25.55.06,1.21.9,1.69l.9.52a4.43,4.43,0,0,0,3.75,0l5.67-3.27a1.2,1.2,0,0,0,.69-1s.06-.34.15-.92A16.63,16.63,0,0,1,62.61,106.8Z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.58,117.67l5.67-3.28a1.18,1.18,0,0,0,.69-1h0s2.06-12.3,1-17.9l-2.77.34-2.87,1.5s0,11.82-3.79,20.67h0s0,0,0,.06A3.81,3.81,0,0,0,58.58,117.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9,118.19a4.86,4.86,0,0,1-2.34-.58l-2.14-1.24c-.78-.45-1.16-1.06-1-1.65h0l.09-.21a52.26,52.26,0,0,0,3.81-17.75v-.12l10.86-1.3,0,.12c1,5.48-.94,17.52-1,17.94a1.34,1.34,0,0,1-.76,1.1l-5.67,3.28A3.78,3.78,0,0,1,56.9,118.19Zm-5.1-3.79-.09.22c-.23.5.1,1.09.84,1.52l2.14,1.24a4.36,4.36,0,0,0,3.89.16l5.67-3.27a1.07,1.07,0,0,0,.62-.89v0c0-.12,2-12.16,1-17.73L55.54,96.88A53,53,0,0,1,51.8,114.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.77,89.93a11.74,11.74,0,0,0-5.32-9.21,3.83,3.83,0,0,0-3.59-.46h0a2.39,2.39,0,0,0-.34.21l-3.84,2.25L59.15,84l7,11.76,3.91-2.29a3.24,3.24,0,0,0,.35-.21h0A3.87,3.87,0,0,0,71.77,89.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.41,91.46a11.91,11.91,0,0,0-5.29-8.56,3.88,3.88,0,0,0-3.6-.46h0a1.75,1.75,0,0,0-.35.2l-3,1.73L66,95.75l3.91-2.29a3.24,3.24,0,0,0,.35-.21h0A3.23,3.23,0,0,0,71.41,91.46Z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.11,95.94,59,84.05l-.54-1.39,3.94-2.31a2.31,2.31,0,0,1,.35-.21,4,4,0,0,1,3.73.46,11.94,11.94,0,0,1,5.39,9.33,4,4,0,0,1-1.43,3.43,3.28,3.28,0,0,1-.37.22ZM58.84,82.77l.44,1.17L66.2,95.57,70,93.34a3.12,3.12,0,0,0,1.65-3.41,11.66,11.66,0,0,0-5.25-9.1,3.76,3.76,0,0,0-3.48-.45,2.59,2.59,0,0,0-.33.19Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.51,
    cy: 89.18,
    rx: 4.34,
    ry: 7.52,
    transform: "translate(-36.22 43.2) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.88,96.18a5,5,0,0,1-2.44-.74,11.92,11.92,0,0,1-5.38-9.33,3.37,3.37,0,0,1,5.52-3.19A11.92,11.92,0,0,1,68,92.25a3.87,3.87,0,0,1-1.62,3.56A2.91,2.91,0,0,1,64.88,96.18ZM60.13,82.45a2.63,2.63,0,0,0-1.31.33,3.6,3.6,0,0,0-1.49,3.33,11.6,11.6,0,0,0,5.25,9.09,3.1,3.1,0,0,0,5.11-3,11.6,11.6,0,0,0-5.25-9.09A4.62,4.62,0,0,0,60.13,82.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.32,92.51a10.57,10.57,0,0,0-4.78-8.28,3.46,3.46,0,0,0-3.23-.41h0A2.59,2.59,0,0,0,58,84L47.61,89.92,48,91.06l6.29,10.57,6.43-3.75c.11,0,4.23-2.32,4.33-2.39h0A3.5,3.5,0,0,0,66.32,92.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.06,94.05a10.65,10.65,0,0,0-4.74-7.62A3.48,3.48,0,0,0,58.08,86h0a1.92,1.92,0,0,0-.31.18l-9.45,5.38,6,10,6.43-3.75c.11,0,4.23-2.32,4.33-2.39h0A2.8,2.8,0,0,0,66.06,94.05Z",
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.17,88.4h0c-.1.07-4.22,2.34-4.33,2.39l-6.43,3.75-3.35-.39-3.47-4.23L48,91.06l6.29,10.57,6.43-3.75c.11,0,4.22-2.32,4.32-2.39h0a3.47,3.47,0,0,0,1.23-3,9.48,9.48,0,0,0-1.09-4.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.28,101.82,47.93,91.13l-.49-1.27,10.49-6a1.93,1.93,0,0,1,.32-.19,3.59,3.59,0,0,1,3.36.42,10.71,10.71,0,0,1,4.84,8.39,3.66,3.66,0,0,1-1.28,3.09C65,95.7,60.85,98,60.82,98ZM47.78,90l.39,1,6.21,10.43,6.31-3.68L65,95.38a3.36,3.36,0,0,0,1.17-2.87,10.42,10.42,0,0,0-4.71-8.16,3.33,3.33,0,0,0-3.1-.41,2.14,2.14,0,0,0-.3.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.83,98.49c0,3-2.13,4.28-4.77,2.76A10.57,10.57,0,0,1,46.28,93c0-3,2.14-4.28,4.78-2.76A10.56,10.56,0,0,1,55.83,98.49Z",
    style: {
      fill: "#fff"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.19,102a4.42,4.42,0,0,1-2.2-.67A10.71,10.71,0,0,1,46.15,93a3.5,3.5,0,0,1,1.46-3.21,3.5,3.5,0,0,1,3.51.34A10.69,10.69,0,0,1,56,98.49a3.49,3.49,0,0,1-1.47,3.21A2.63,2.63,0,0,1,53.19,102ZM48.92,89.69a2.23,2.23,0,0,0-1.17.31,3.22,3.22,0,0,0-1.34,3,10.45,10.45,0,0,0,4.71,8.16,2.78,2.78,0,0,0,4.58-2.64A10.42,10.42,0,0,0,51,90.33,4.26,4.26,0,0,0,48.92,89.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.34,98.68a9.14,9.14,0,0,0-4.13-7.16c-1.34-.78-2.53-.73-3.29,0-1.83,1-7.19,3-14.14-1.6a.53.53,0,0,0-.79.64L42.47,116.4l2.06.4a1.72,1.72,0,0,0,2-1.86c-.33-3.38,0-9.62,5.91-13.35C53.61,101.38,54.34,100.34,54.34,98.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.31,101.65a2.13,2.13,0,0,0,1.59-1.39,9.25,9.25,0,0,0-4.08-6.36c-1.34-.77-2.53-.72-3.28,0-1.83,1-7.13,3-14-1.51l9.76,24.09,2.05.4a1.71,1.71,0,0,0,1.78-.74,16.69,16.69,0,0,1,.19-3.22A13,13,0,0,1,52.31,101.65Z",
    style: {
      fill: "#fff"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.87,117a2.31,2.31,0,0,1-.37,0l-2.13-.42L31.87,90.58a.65.65,0,0,1,.19-.76.66.66,0,0,1,.8,0c6.8,4.55,12,2.65,14,1.6.84-.76,2.09-.76,3.43,0a9.3,9.3,0,0,1,4.21,7.28c0,1.66-.73,2.8-1.94,3-5.83,3.69-6.15,9.86-5.83,13.21a1.84,1.84,0,0,1-.6,1.56A1.87,1.87,0,0,1,44.87,117Zm-2.3-.69,2,.39a1.58,1.58,0,0,0,1.38-.38,1.56,1.56,0,0,0,.51-1.33c-.33-3.42,0-9.71,6-13.48l0,0c1.09-.2,1.74-1.24,1.74-2.78a9,9,0,0,0-4.07-7.05c-1.24-.71-2.38-.73-3.13,0l0,0c-2,1.07-7.34,3-14.28-1.6a.38.38,0,0,0-.48,0,.38.38,0,0,0-.11.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.89,121.74a4.83,4.83,0,0,0,.56-.71h0a12.16,12.16,0,0,0,1.83-6.94c0-8.94-6.28-19.82-14-24.29-3.64-2.1-6.95-2.42-9.44-1.24a2.39,2.39,0,0,0-.22.12l-.11.06a1.92,1.92,0,0,0-.31.18l-.06,0-.31.21c-4,2.77-4.31,8-4.31,8l.73.71v0c0,6.19,3,13.31,7.44,18.59a14.12,14.12,0,0,0,6.22,6.27c3.74,1.67,6.52,1.68,8.51,1.12a6.75,6.75,0,0,0,3.33-2l.14-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.09,120.79c.38-.42,0-1.4,0-1.4l.36.67c1.17-1.69,2.79-2.3,2.79-5.21,0-8.95-6.28-19.82-14-24.3-3.63-2.09-6.94-2.41-9.43-1.23l-.23.11-.1.06-.31.18-.06,0a3.37,3.37,0,0,0-.31.21c-4,2.77-4.31,8-4.31,8l.73.71v0c0,6.2,3,13.32,7.44,18.6,1.55,2.74,4.17,3.62,6.81,4.79,3.74,1.67,4.82,1.12,6.81.56,1.29-.32,1.86-.3,2.77-1.28,0,0,0-1.89,1-.53C44.1,120.8,44.08,120.8,44.09,120.79Z",
    style: {
      fill: "#fff"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.28,114.15A25.83,25.83,0,0,0,45.4,105a11,11,0,0,1-1.77,5.42h0a4.29,4.29,0,0,1-.55.71l0,0-.13.14a6.82,6.82,0,0,1-3.34,2c-2,.56-4.76.55-8.51-1.12a14.15,14.15,0,0,1-6.21-6.27,33.79,33.79,0,0,1-6-10.62,11.59,11.59,0,0,0-.35,2l.73.71v0c0,6.2,3,13.32,7.44,18.6a14.17,14.17,0,0,0,6.22,6.27c3.74,1.66,6.52,1.68,8.5,1.11a6.72,6.72,0,0,0,3.34-2,1.85,1.85,0,0,1,.14-.14l0,0a4.83,4.83,0,0,0,.56-.71h0A12.16,12.16,0,0,0,47.28,114.15Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9,124.34a15.08,15.08,0,0,1-6.07-1.47,14.24,14.24,0,0,1-6.28-6.32c-4.58-5.47-7.44-12.61-7.45-18.63l-.73-.72v-.06s.34-5.33,4.36-8.1l.32-.21.06,0,.31-.18,0,0,.06,0a1.34,1.34,0,0,1,.24-.12c2.62-1.24,6-.8,9.55,1.24,7.77,4.49,14.09,15.44,14.09,24.41a12.37,12.37,0,0,1-1.83,7v0a5.46,5.46,0,0,1-.58.73v0a2.11,2.11,0,0,1-.15.15,6.84,6.84,0,0,1-3.4,2A9.48,9.48,0,0,1,38.9,124.34ZM18.64,97.1l.73.7v.06c0,6,2.83,13.08,7.4,18.53,1.76,3.1,3.83,5.19,6.17,6.24,3.19,1.42,6,1.79,8.42,1.11a6.54,6.54,0,0,0,3.27-1.92l.14-.14.12.06-.1-.09a5.05,5.05,0,0,0,.49-.61h0l.06-.09a12.12,12.12,0,0,0,1.81-6.87c0-8.89-6.27-19.73-14-24.18-3.46-2-6.76-2.43-9.31-1.23l-.22.11-.11.07-.3.17-.06,0-.3.2C19.2,91.8,18.69,96.51,18.64,97.1Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.61,
    cy: 106.8,
    rx: 10.81,
    ry: 18.72,
    transform: "translate(-49.17 30.12) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.89,104.19a27.61,27.61,0,0,1,9.94,11c0-.22,0-.45,0-.67,0-8.44-5.93-18.71-13.24-22.93s-13.23-.79-13.23,7.65a26.36,26.36,0,0,0,3.29,12C22,103.22,27.78,100.09,34.89,104.19Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.53,124a12.1,12.1,0,0,1-6-1.83c-7.34-4.23-13.3-14.57-13.3-23,0-4.13,1.4-7.21,3.94-8.68s5.91-1.14,9.49.93C39,95.64,45,106,45,114.44c0,4.14-1.4,7.22-3.94,8.69A7,7,0,0,1,37.53,124ZM25.7,89.84a6.7,6.7,0,0,0-3.38.87c-2.45,1.42-3.81,4.42-3.81,8.45,0,8.39,5.91,18.62,13.17,22.81,3.49,2,6.77,2.34,9.23.93s3.8-4.42,3.8-8.46c0-8.38-5.9-18.61-13.16-22.8A12,12,0,0,0,25.7,89.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.45,102.3,35,110l8.39-3.43a31.89,31.89,0,0,0-5.56-9.72L30.52,102A.21.21,0,0,0,30.45,102.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.21,98.51l-6.94,4.87,3.81,6.5,8.06-3.29A31.88,31.88,0,0,0,38.21,98.51Z",
    style: {
      fill: "#fff"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.94,110.21l-4.6-7.84a.35.35,0,0,1,.1-.46l7.4-5.2.08.09a32,32,0,0,1,5.59,9.76l0,.13Zm-4.37-8,4.48,7.63,8.16-3.34a31.59,31.59,0,0,0-5.41-9.46l-7.21,5.06a.09.09,0,0,0,0,.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.88,108a7.18,7.18,0,0,0-3.24-5.62,2.12,2.12,0,0,0-2.58,0h0a1.78,1.78,0,0,0-.39.54l-.7,1,.44.75a7.37,7.37,0,0,0,2.93,5.07l.45.77,1.38-.15.22,0h0C35.29,110.13,35.88,109.31,35.88,108Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6,103.43a2.11,2.11,0,0,0-2.58,0h0a1.57,1.57,0,0,0-.39.54l-.39.52.13.22a7.33,7.33,0,0,0,2.93,5.06l.45.78,1.38-.15.22,0h0a1.86,1.86,0,0,0,1.46-1.81A7.25,7.25,0,0,0,32.6,103.43Z",
    style: {
      fill: "#fff"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.72,110.6l-.48-.83a7.49,7.49,0,0,1-3-5.12l-.47-.8.75-1a1.9,1.9,0,0,1,.39-.55l.05-.07-.05.07a2.37,2.37,0,0,1,2.75,0A7.3,7.3,0,0,1,36,108c0,1.35-.59,2.25-1.6,2.42l-.23,0Zm-3.59-6.73.41.73a7.19,7.19,0,0,0,2.88,5l0,0,.42.73,1.3-.14.21,0c.86-.15,1.37-1,1.37-2.16a7,7,0,0,0-3.17-5.5,2,2,0,0,0-2.42,0h0a1.53,1.53,0,0,0-.36.5Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.54,
    cy: 106.77,
    rx: 2.33,
    ry: 4.03,
    transform: "translate(-49.16 30.08) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.82,110.59a2.76,2.76,0,0,1-1.35-.41,6.47,6.47,0,0,1-2.91-5.05,2.15,2.15,0,0,1,.9-2,2.15,2.15,0,0,1,2.15.2,6.47,6.47,0,0,1,2.92,5.06,2.11,2.11,0,0,1-.91,2A1.57,1.57,0,0,1,32.82,110.59Zm-2.55-7.37a1.3,1.3,0,0,0-.68.18,1.88,1.88,0,0,0-.77,1.73A6.16,6.16,0,0,0,31.61,110a1.9,1.9,0,0,0,1.88.2,1.87,1.87,0,0,0,.77-1.73,6.15,6.15,0,0,0-2.79-4.82A2.4,2.4,0,0,0,30.27,103.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.61,91.52c-7.3-4.22-13.23-.8-13.23,7.64s5.93,18.7,13.23,22.92,13.24.8,13.24-7.64S38.92,95.74,31.61,91.52Zm0,28.52c-6.33-3.66-11.46-12.54-11.46-19.86s5.13-10.27,11.46-6.61,11.47,12.54,11.47,19.85S38,123.7,31.61,120Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.75,114.46c0-.55,0-1.11-.08-1.67-1.25-7.67-6.57-16-13-19.64-7.31-4.22-13.24-.8-13.24,7.64,0,.55,0,1.11.08,1.67,1.25,7.67,6.57,16,13,19.64C38.82,126.32,44.75,122.9,44.75,114.46ZM20.31,103.14a17.54,17.54,0,0,1-.26-2.94c0-7.31,5.13-10.27,11.46-6.62,6,3.44,10.85,11.5,11.41,18.53a17.54,17.54,0,0,1,.26,2.94c0,7.31-5.13,10.27-11.46,6.62C25.76,118.23,20.87,110.17,20.31,103.14Z",
    style: {
      fill: "#fff"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.53,124a12.1,12.1,0,0,1-6-1.83c-7.34-4.23-13.3-14.57-13.3-23,0-4.13,1.4-7.21,3.94-8.68s5.91-1.14,9.49.93C39,95.64,45,106,45,114.44c0,4.14-1.4,7.22-3.94,8.69A7,7,0,0,1,37.53,124ZM25.7,89.84a6.7,6.7,0,0,0-3.38.87c-2.45,1.42-3.81,4.42-3.81,8.45,0,8.39,5.91,18.62,13.17,22.81,3.49,2,6.77,2.34,9.23.93s3.8-4.42,3.8-8.46c0-8.38-5.9-18.61-13.16-22.8A12,12,0,0,0,25.7,89.84Zm11,31.9a10.58,10.58,0,0,1-5.18-1.58c-6.36-3.67-11.53-12.63-11.53-20,0-3.58,1.21-6.26,3.42-7.53s5.14-1,8.24.8c6.36,3.67,11.53,12.63,11.53,20,0,3.59-1.21,6.26-3.42,7.54A6.08,6.08,0,0,1,36.73,121.74ZM26.5,92.13a5.75,5.75,0,0,0-2.92.75c-2.13,1.22-3.3,3.82-3.3,7.3,0,7.26,5.12,16.12,11.4,19.74,3,1.75,5.85,2,8,.81s3.29-3.82,3.29-7.31c0-7.25-5.11-16.11-11.39-19.74A10.32,10.32,0,0,0,26.5,92.13Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.69,93l-.1,0a.31.31,0,0,0-.39,0l-1.68,1a1.29,1.29,0,0,0-.55,1,.44.44,0,0,0,.16.41l0,0,.71.43,1.07-1,1-1,.37-.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.87,95.93,61,95.42a.59.59,0,0,1-.2-.52,1.44,1.44,0,0,1,.61-1.15l1.68-1a.48.48,0,0,1,.55,0l.08,0,.69.41-.46.65-1,1Zm1.53-3a.24.24,0,0,0-.14,0l-1.68,1a1.15,1.15,0,0,0-.47.91c0,.24.07.29.09.3l0,0,.61.37,1-.9.95-1,.27-.4L63.52,93A.21.21,0,0,0,63.4,93Z",
    style: {
      fill: "#fff"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.91,94.78l-1.68,1c-.3.17-.54,0-.54-.41h0a1.28,1.28,0,0,1,.54-1l1.68-1c.3-.18.54,0,.54.41h0A1.29,1.29,0,0,1,63.91,94.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62,96a.36.36,0,0,1-.2-.06.6.6,0,0,1-.26-.55,1.43,1.43,0,0,1,.61-1.15l1.68-1a.48.48,0,0,1,.49,0,.63.63,0,0,1,.25.56,1.4,1.4,0,0,1-.6,1.14l-1.68,1A.57.57,0,0,1,62,96Zm2.11-2.54a.33.33,0,0,0-.14,0l-1.68,1a1.17,1.17,0,0,0-.48.92.37.37,0,0,0,.12.32.22.22,0,0,0,.22,0l1.68-1a1.16,1.16,0,0,0,.47-.91c0-.16,0-.28-.12-.32A.08.08,0,0,0,64.12,93.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.06,117.26a47.78,47.78,0,0,0,2.32-8.55,3.61,3.61,0,0,1,1.73-2.52L66,104.52l0-.33L63,106a3.92,3.92,0,0,0-1.87,2.7,47.23,47.23,0,0,1-2.42,8.82Z",
    style: {
      fill: "#fff"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "58.61 117.67 58.53 117.88 58.65 117.81 58.61 117.67"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.42,95.13s-6.61,2.28-8.83,7.4a1.11,1.11,0,0,1-.07.16,29.69,29.69,0,0,1,2.38,7.06,12.42,12.42,0,0,1,5.66-8.17c1.12-.21,1.85-1.25,1.85-2.91A9.17,9.17,0,0,0,53.42,95.13Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "67.02 88.57 71 86.31 71.64 88.47 71.77 90.49 71.45 91.81 70.86 92.84 69.39 93.84 66.86 95.34 67.69 93.69 67.82 91.99 67.5 89.94 67.02 88.57"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.64,97.79l-.14.08v.32l.28-.16,3.44-1.9-.4-.08C62.57,96.73,60.77,97.73,60.64,97.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.61,105.38l-.08.56a28.8,28.8,0,0,1,1.09,3.93l.14-.63A28.24,28.24,0,0,0,45.61,105.38Z",
    style: {
      fill: "#fff"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.24,105.38l2.4-1.27s.32-.16,2.47-1.36l.33.71c.9,1.88,1.55,3.66,1.55,3.66l-6.75,2.67.48-.72.16-1.08-.14-1.66Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "41.78 107.16 40.02 107.88 40.22 108.09 41.85 107.42 41.78 107.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.48,33,.5,60.69l48,27.71,48-27.71Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L.5,60.69V116.1l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "BRAND"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "103.86 0.29 151.84 27.99 151.84 83.4 103.86 111.1 55.88 83.4 55.88 27.99 103.86 0.29",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,83.52,104,55.7m0,0L103.86.29M104,55.7l47.54,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,91.33a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.48A1,1,0,0,1,110,91.33Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.21,90.06c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,112.21,90.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.41,88.79a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,114.41,88.79Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.4,
    cy: 90.3,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,88.79a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0c-.24-.14-.24-.35,0-.49A1,1,0,0,1,110,88.79Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.79,
    cy: 87.77,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,88.79c.24.14.24.35,0,.49a1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,105.62,88.79Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82,87.52c.23.14.23.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,107.82,87.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,86.26a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.48A.89.89,0,0,1,110,86.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.01,
    cy: 87.77,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,86.26c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,105.62,86.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.4,
    cy: 85.23,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,86.26a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,101.23,86.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,85a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.48A.89.89,0,0,1,103.43,85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,83.72c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A1,1,0,0,1,105.62,83.72Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,85c.24.14.24.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,99,85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,83.71a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,101.21,83.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.41,82.44a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,103.41,82.44Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.82,83.71a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,96.82,83.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.59,
    cy: 82.68,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.79,
    cy: 81.41,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,82.44a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,94.62,82.44Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.82,81.17c.23.13.23.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,96.82,81.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,79.9c.24.14.24.35,0,.49a1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,99,79.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 81.41,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,79.9a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,94.62,79.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.4,
    cy: 78.88,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.23,79.9a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,90.23,79.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.42,78.63c.24.14.24.35,0,.49a1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,92.42,78.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,77.37a.25.25,0,0,1,0,.48,1,1,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,94.62,77.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.61,
    cy: 78.88,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.23,77.37a.25.25,0,0,1,0,.48,1,1,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,90.23,77.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 76.34,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.83,77.37c.24.13.24.35,0,.48a1,1,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,85.83,77.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,76.1a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,88,76.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.23,74.83a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,90.23,74.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.83,74.83c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,85.83,74.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,73.56c.23.13.23.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,88,73.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.69,92.39c.23.14.23.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,116.69,92.39Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.89,91.13a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,118.89,91.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.88,
    cy: 92.64,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.08,
    cy: 91.37,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.27,
    cy: 90.1,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.62,87.54c.24.13.24.35,0,.48a1,1,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,116.62,87.54Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.82,86.27a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,118.82,86.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.62,85c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,116.62,85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.39,85a1,1,0,0,1,.84,0,.25.25,0,0,1,0,.48.92.92,0,0,1-.84,0C111.16,85.35,111.16,85.13,111.39,85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.43,83.73c.23.13.23.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,114.43,83.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.19,83.73a1,1,0,0,1,.84,0c.23.13.23.35,0,.49a1,1,0,0,1-.84,0A.26.26,0,0,1,109.19,83.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23,82.46a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,112.23,82.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,82.46a1,1,0,0,1,.85,0,.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0C106.76,82.82,106.76,82.6,107,82.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.61,
    cy: 81.44,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23,80.41a1,1,0,0,1-.84,0,.25.25,0,0,1,0-.48C111.62,79.79,112.46,80.28,112.23,80.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.2,
    cy: 81.42,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.4,
    cy: 80.16,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,79.13a1,1,0,0,1-.84,0c-.24-.13-.24-.35,0-.49S110.25,79,110,79.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,79.91a1,1,0,0,1,.84,0c.24.14.24.35,0,.49a1,1,0,0,1-.84,0C102.35,80.27,102.35,80.05,102.58,79.91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,78.64c.23.14.23.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,105.62,78.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82,77.86a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48C107.21,77.24,108.05,77.73,107.82,77.86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.39,78.65a.92.92,0,0,1,.84,0c.23.14.23.36,0,.49a1,1,0,0,1-.84,0C100.16,79,100.15,78.78,100.39,78.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,77.38a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.48A.89.89,0,0,1,103.43,77.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.19,77.38a.89.89,0,0,1,.84,0,.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0A.25.25,0,0,1,98.19,77.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,76.11a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,101.23,76.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,76.11a.92.92,0,0,1,.84,0c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0A.25.25,0,0,1,96,76.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,74.84a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A1,1,0,0,1,99,74.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8,74.84a1,1,0,0,1,.84,0c.23.13.23.35,0,.49a1,1,0,0,1-.84,0C93.57,75.19,93.56,75,93.8,74.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.84,73.57a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0c-.24-.14-.24-.35,0-.49a1,1,0,0,1,.84,0C97.07,73.71,96.6,73.44,96.84,73.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,73.57a1,1,0,0,1,.84,0,.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0A.26.26,0,0,1,91.6,73.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.64,72.3a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49,1,1,0,0,1,.84,0C94.87,72.44,94.41,72.17,94.64,72.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4,72.3a1,1,0,0,1,.84,0c.24.14.24.35,0,.49a1,1,0,0,1-.84,0C89.17,72.66,89.17,72.44,89.4,72.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.26,89.87a1,1,0,0,1,.84,0,.25.25,0,0,1,0,.48.92.92,0,0,1-.84,0C120,90.22,120,90,120.26,89.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.06,88.6a1,1,0,0,1,.84,0c.24.13.24.35,0,.49a1,1,0,0,1-.84,0C117.83,89,117.83,88.74,118.06,88.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,87.33c.24.14.24.35,0,.49a1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,121.1,87.33Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.92,53.37c0-7.91-5.56-17.53-12.41-21.49-3.35-1.93-6.38-2.14-8.62-.94h0l-.09,0-.09.06-2.92,1.7a.35.35,0,0,0,0,.59l1.74,1.15a13.23,13.23,0,0,0-.42,3.42c0,7.9,5.55,17.52,12.4,21.48a14.13,14.13,0,0,0,2.68,1.2l.65,2.25a.4.4,0,0,0,.58.23l2.8-1.63.18-.11.19-.1v0C115.64,59.84,116.92,57.15,116.92,53.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.19,63.54a.8.8,0,0,1-.3-.06.83.83,0,0,1-.47-.52l-.59-2.05a13.83,13.83,0,0,1-2.55-1.17c-7-4-12.61-13.81-12.61-21.83A13.63,13.63,0,0,1,94,34.67l-1.5-1A.74.74,0,0,1,92.2,33a.77.77,0,0,1,.37-.63l3.27-1.91h0c2.44-1.23,5.57-.87,8.86,1,7,4,12.61,13.81,12.61,21.84,0,3.7-1.22,6.57-3.42,8.09v0l-.51.32-2.79,1.63A.87.87,0,0,1,110.19,63.54ZM93.08,33.05,95,34.31l-.07.28a13.19,13.19,0,0,0-.41,3.32c0,7.76,5.47,17.24,12.2,21.12a13,13,0,0,0,2.6,1.17l.21.07.71,2.46,3.13-1.87c2-1.34,3.17-4,3.17-7.49,0-7.77-5.47-17.25-12.2-21.13-3.1-1.79-6-2.12-8.22-.94l-.16.09h0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.08,82.23l6.07-24.09-7.38-6.43L91.7,75.8c-.1.4.37,1,.67.85L96.05,75c.2-.09.51.18.6.52l1.65,6.35C98.44,82.34,99,82.62,99.08,82.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,82.82a1.12,1.12,0,0,1-1-.9l-1.66-6.34a.42.42,0,0,0-.12-.21L92.54,77a.74.74,0,0,1-.79-.15,1.26,1.26,0,0,1-.44-1.17L97.54,51l8.07,7L99.48,82.33a.62.62,0,0,1-.6.49Zm-2.74-8.29a.7.7,0,0,1,.31.07,1.2,1.2,0,0,1,.61.77l1.65,6.35a.5.5,0,0,0,0,.13l5.94-23.57L98,52.46,92.1,75.9a.51.51,0,0,0,.17.35l3.61-1.67A.53.53,0,0,1,96.13,74.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.31,88.33l-5.91-31L100,55.12l5.91,31.05c.1.51.64.86.78.5l1.68-4.41c.09-.23.41-.14.61.18l3.65,6C112.94,88.89,113.41,88.84,113.31,88.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,89.15a1,1,0,0,1-.81-.53l-3.63-5.93-1.58,4.12a.6.6,0,0,1-.63.41,1.17,1.17,0,0,1-.93-1l-6-31.71L107.76,57l6,31.3a.71.71,0,0,1-.39.86A.62.62,0,0,1,113.1,89.15Zm-4.53-7.43a1,1,0,0,1,.77.5l3.48,5.68-5.77-30.3-6.51-1.9,5.79,30.39a.4.4,0,0,0,.08.2L108,82.12a.6.6,0,0,1,.51-.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.37,
    cy: 48.03,
    rx: 10.13,
    ry: 17.54,
    transform: "translate(-10.43 57.12) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.91,64.46a11.61,11.61,0,0,1-5.74-1.75c-7-4-12.61-13.81-12.61-21.84,0-4,1.36-6.95,3.84-8.38s5.73-1.12,9.18.87c7,4,12.61,13.81,12.61,21.83,0,4-1.37,7-3.84,8.39A6.8,6.8,0,0,1,106.91,64.46Zm-11.07-32a6,6,0,0,0-3,.78c-2.21,1.27-3.43,4-3.43,7.67,0,7.77,5.47,17.25,12.2,21.13,3.18,1.84,6.15,2.15,8.36.87s3.43-4,3.43-7.68c0-7.76-5.47-17.24-12.2-21.12A10.81,10.81,0,0,0,95.84,32.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ACTIVE",
    cx: 101.63,
    cy: 48.03,
    rx: 7.91,
    ry: 13.7,
    transform: "translate(-10.4 57.25) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7,61a9.17,9.17,0,0,1-4.53-1.38c-5.45-3.15-9.89-10.83-9.89-17.13,0-3.14,1.08-5.49,3-6.62s4.54-.89,7.26.68c5.45,3.14,9.89,10.83,9.89,17.12,0,3.14-1.08,5.5-3,6.63A5.41,5.41,0,0,1,105.7,61Zm-8.65-25a4.56,4.56,0,0,0-2.32.6c-1.7,1-2.63,3.08-2.63,5.91,0,6,4.25,13.4,9.48,16.42,2.45,1.42,4.74,1.66,6.44.68s2.63-3.08,2.63-5.92c0-6-4.25-13.4-9.48-16.42A8.45,8.45,0,0,0,97.05,35.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,53l-3.86-7.63c-.53-1-.44-2.1.2-2.34h0c.65-.24,1.6.41,2.14,1.47l2,4,4.44-3.75c.53-.44,1.49,0,2.14,1h0c.64,1,.74,2.14.22,2.58l-6.26,5.28C100.27,53.82,99.77,53.53,99.5,53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.32,54.08l-.18,0a1.61,1.61,0,0,1-1-.88l-3.85-7.62a2.82,2.82,0,0,1-.27-2.2,1.16,1.16,0,0,1,.69-.71c.85-.32,2,.41,2.64,1.66l1.8,3.54,4-3.41a1.22,1.22,0,0,1,1-.26,2.8,2.8,0,0,1,1.77,1.32c.77,1.17.83,2.54.14,3.13l-6.26,5.28A.74.74,0,0,1,100.32,54.08Zm-.46-1.27a.78.78,0,0,0,.46.45h0L106.53,48c.32-.27.26-1.2-.29-2A2.1,2.1,0,0,0,105,45a.39.39,0,0,0-.32.07l-4.84,4.09-2.26-4.47c-.45-.9-1.24-1.41-1.62-1.27,0,0-.15.06-.22.25A2.08,2.08,0,0,0,96,45.19Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.3 47.29 115.27 45.45 116.51 49.03 116.92 54.54 116.51 57.83 113.07 61.66 111.69 62.23 112.81 60.18 113.74 56.8 113.74 52.46 112.3 48.03 112.3 47.29",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.86.29,55.88,28l48,27.71,48-27.71Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L55.88,28V83.4l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFgLight4);
export default __webpack_public_path__ + "static/media/ICON_fg_light_4.a86589d9bc56758c7b435875388af2fc.svg";
export { ForwardRef as ReactComponent };